import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { messages } from './messages';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import PrintDocumentMenuItem from '../../../print-document-menu-item';
import { useFulfillmentPlanInformation } from '../hooks/use-fulfillment-plan-information';
import { usePickListDisabledCheck, useBatchAction } from '../hooks/use-pick-list';

export const PickList = ({ fulfillmentPlans, printSetting, salesOrders, isUseCustomerDocType = false }) => {
  const dispatch = useDispatch();
  const { fulfillmentPlanIds } = useFulfillmentPlanInformation(fulfillmentPlans);
  const { isDisabled, onClick, isFeatureEnabled } = usePickListDisabledCheck({
    fulfillmentPlans,
    salesOrders,
    isUseCustomerDocType,
  });

  const batchActionCreator = useBatchAction(fulfillmentPlanIds);

  const onPrint = useCallback(() => {
    if (batchActionCreator) {
      dispatch(batchActionCreator());
      return;
    }
    dispatch(printDocument(DocumentType.PickList, fulfillmentPlanIds, printSetting));
  }, [dispatch, fulfillmentPlanIds, printSetting, batchActionCreator]);
  const onDownload = useCallback(() => {
    if (batchActionCreator) {
      dispatch(batchActionCreator());
      return;
    }
    dispatch(downloadDocument(DocumentType.PickList, fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds, batchActionCreator]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSetting, onPrint, onDownload),
    [onDownload, onPrint, printSetting],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      isFeatureEnabled={isFeatureEnabled}
      name={isUseCustomerDocType ? messages.pickListNew : DocumentType.PickList.documentNameTranslation}
      onClick={onClick}
    />
  );
};

PickList.propTypes = {
  fulfillmentPlans: PropTypes.array.isRequired,
  printSetting: PropTypes.any,
  salesOrders: PropTypes.array.isRequired,
  isUseCustomerDocType: PropTypes.bool,
};
